// src/pages/VendorTerms.js
import React from 'react';
import { Link } from 'react-router-dom';
import './VendorTerms.css';

const VendorTerms = () => {
  return (
    <div className="legal-page">
      {/* Page Header */}
      <header className="legal-header">
        <div className="legal-header-content">
          <Link to="/" className="legal-back-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Back to Home
          </Link>

          <h1 className="legal-title">Partner Vendor Terms</h1>
          <p className="legal-subtitle">
            QSlot Partner – Applicable to Registered Vendors. By registering on
            the Platform, you agree to be bound by these legally enforceable
            terms.
          </p>
        </div>
      </header>

      {/* Content */}
      <main className="legal-container">
        {/* 1. Preamble */}
        <section className="legal-section">
          <h2 className="legal-section-title">1. Preamble</h2>
          <p>
            This Vendor Terms and Agreement ("Agreement") is entered into by and
            between <strong>Fewas Technologies Private Limited</strong>, a
            company registered under the Companies Act, 2013, having its office
            at No.32, Masakalipalayam Road, Lakshmipuram 4th Street, Peelamedu,
            Coimbatore – 641004 ("Company", "We", "Us", or "Our"), and the
            vendor ("Vendor", "You", "Your") who agrees to list and provide car
            wash services or manage turf slot bookings through the mobile
            application developed and owned by the Company.
          </p>
        </section>

        {/* 2. Definitions */}
        <section className="legal-section">
          <h2 className="legal-section-title">2. Definitions</h2>
          <p>
            By registering on the Platform and using our services, the Vendor
            agrees to be bound by this legally enforceable Agreement.
          </p>
          <ul className="legal-list">
            <li>
              <strong>"Platform":</strong> The software and technology solution
              developed and maintained by Fewas Technologies Private Limited,
              including mobile applications and web interfaces.
            </li>
            <li>
              <strong>"Vendor":</strong> Any person or legal entity that is
              registered to provide services such as car washing or turf slot
              management via the Platform.
            </li>
            <li>
              <strong>"User":</strong> Any individual or entity using the App to
              avail car washing or turf booking services from the Vendor.
            </li>
            <li>
              <strong>"Services":</strong> The specific activities offered by
              Vendors via the Platform including but not limited to car wash,
              turf management, cleaning, maintenance, etc.
            </li>
            <li>
              <strong>"Booking":</strong> A service reservation made by a User
              through the Platform.
            </li>
            <li>
              <strong>"Commission":</strong> The percentage of the booking
              amount deducted by the Company for facilitating the service.
            </li>
          </ul>
        </section>

        {/* 3. Vendor Onboarding */}
        <section className="legal-section">
          <h2 className="legal-section-title">3. Vendor Onboarding &amp; Eligibility</h2>
          <p>To be eligible to use the Platform as a Vendor, the Vendor must:</p>
          <ul className="legal-list">
            <li>
              Submit necessary KYC documents, including but not limited to:
              <ul className="legal-list legal-list-nested">
                <li>Aadhaar/PAN/GST Certificate</li>
                <li>Business Registration License (if applicable)</li>
                <li>Bank Account Details</li>
              </ul>
            </li>
            <li>Have the legal right to offer services as a business or individual.</li>
            <li>
              Undergo a vetting process, which may include service quality
              inspection, interviews, and verification of facilities or turf.
            </li>
          </ul>
          <p>
            The Company reserves the right to approve, reject, or terminate a
            vendor's listing based on quality control standards.
          </p>
        </section>

        {/* 4. Scope of Services */}
        <section className="legal-section">
          <h2 className="legal-section-title">4. Scope of Services</h2>
          <p>
            Vendors shall offer services to Users as listed in their profile on
            the Platform, such as:
          </p>
          <ul className="legal-list">
            <li>
              <strong>Car Wash Vendors:</strong> Interior/exterior washing,
              detailing, polishing, etc.
            </li>
            <li>
              <strong>Turf Operators:</strong> Slot-based turf rental, light
              management, game management (if applicable).
            </li>
          </ul>
          <p>All services must be accurately described and updated regularly.</p>
        </section>

        {/* 5. Vendor Responsibilities */}
        <section className="legal-section">
          <h2 className="legal-section-title">5. Vendor Responsibilities</h2>

          <h3 className="legal-subsection-title">Service Fulfilment</h3>
          <ul className="legal-list">
            <li>
              Vendors must fulfil all confirmed bookings in a timely and
              professional manner.
            </li>
            <li>Services must be rendered as described on the Platform.</li>
            <li>
              Delays or failure to render services must be promptly communicated
              through the Platform and/or support channels.
            </li>
          </ul>

          <h3 className="legal-subsection-title">Accuracy and Availability</h3>
          <ul className="legal-list">
            <li>
              Vendors must update their real-time availability, pricing, and
              service descriptions.
            </li>
            <li>
              Misleading or false representation may lead to account suspension.
            </li>
          </ul>

          <h3 className="legal-subsection-title">Equipment and Staff</h3>
          <ul className="legal-list">
            <li>
              Vendors shall maintain necessary tools, resources, staff, and
              licenses to deliver services effectively.
            </li>
            <li>
              Staff must be trained and adhere to hygiene, safety, and
              professional standards.
            </li>
          </ul>

          <h3 className="legal-subsection-title">Communication</h3>
          <p>
            Vendors are expected to respond to bookings, cancellations, or
            queries promptly via the App or any official communication channel
            provided by the Company.
          </p>
        </section>

        {/* 6. Commissions, Fees & Payouts */}
        <section className="legal-section">
          <h2 className="legal-section-title">6. Commissions, Fees &amp; Payouts</h2>

          <h3 className="legal-subsection-title">Commission</h3>
          <p>
            The Company shall charge a commission fee (typically ranging from
            <strong> 5–15%</strong>) per successful booking. The exact rate will
            be specified in a separate written addendum or email confirmation or
            displayed on the booking page.
          </p>

          <h3 className="legal-subsection-title">Payment Cycle</h3>
          <p>
            Payouts to Vendors will be made upon the withdrawal request by vendor
            through the APP <strong>[Minimum withdrawal request must be Rs.500]</strong> after
            deductions of:
          </p>
          <ul className="legal-list">
            <li>Platform commission</li>
            <li>Taxes (if applicable)</li>
            <li>Refunds (if any)</li>
          </ul>

          <h3 className="legal-subsection-title">Refund Handling</h3>
          <p>
            Refunds issued to users due to Vendor non-fulfilment or service
            quality failure may be adjusted against future payouts or charged to
            the Vendor.
          </p>

          <h3 className="legal-subsection-title">Payment Disputes</h3>
          <p>
            Vendors must raise any disputes related to payouts or commissions
            within <strong>7 working days</strong> from receipt of statement.
          </p>
        </section>

        {/* 7. Cancellation Method and Charges */}
        <section className="legal-section">
          <h2 className="legal-section-title">7. Cancellation Method and Charges</h2>

          <h3 className="legal-subsection-title">7.1 Cancellation by Vendor</h3>
          <p>
            Vendors must comply with the policy to cancel a confirmed service
            (car wash or turf booking) through the QSLOT vendor dashboard or by
            notifying the Company and user via official communication channels
            (email or app support).
          </p>
          <p>Failure to comply with the minimum notice period may result in:</p>
          <ul className="legal-list">
            <li>The user will receive a full refund including the platform fee.</li>
            <li>Penalty Fee of up to 10% of the service value, and/or</li>
            <li>
              Temporary suspension of vendor listing on the platform for
              repeated violations.
            </li>
          </ul>

          <h4 className="legal-sub-sub-title">TURF:</h4>
          <ul className="legal-list">
            <li>
              Vendors may cancel a user's booking only if the cancellation is
              made at least 2 hours prior to the scheduled slot time.
            </li>
            <li>
              A notification will be sent to the user with an option to either
              reschedule or information about the cancellation of the booking.
            </li>
            <li>
              If the user chooses to reschedule, no charges will apply to the
              user, while the vendor will be charged 9% of the total booking
              amount.
            </li>
            <li>
              If the cancellation is accepted, the user will receive a full
              refund including the platform fee, and the vendor will be charged
              9% of the total booking amount as a cancellation fee.
            </li>
            <li>
              No Cancellation allowed to make if less than 2 hours from the
              scheduled slot time.
            </li>
          </ul>

          <h4 className="legal-sub-sub-title">CAR WASH:</h4>
          <ul className="legal-list">
            <li>
              Vendors may cancel a user's booking only if the cancellation is
              made at least 1 hour prior to the scheduled slot time.
            </li>
            <li>
              If vendor cancels, the user will receive a full refund including
              the platform fee, and the vendor will be charged 9% of the total
              booking amount as a cancellation fee.
            </li>
            <li>
              No Cancellation allowed to make if less than 1 hour from the
              scheduled slot time.
            </li>
          </ul>

          <h3 className="legal-subsection-title">7.2 Cancellation by User</h3>

          <h4 className="legal-sub-sub-title">TURF:</h4>
          <p>
            <strong>
              Cancellations 2 Hours or More Before the Scheduled Slot:
            </strong>
          </p>
          <ul className="legal-list">
            <li>Platform fee is non-refundable.</li>
            <li>
              Full payment made: 95% of the full amount will be refunded to the
              user through the original payment method, while 5% will be
              retained by the app.
            </li>
            <li>
              Advance payment only: 75% of the advance payment will be refunded
              to the user through the original payment method while 25% will be
              retained by the app.
            </li>
          </ul>
          <p>
            <strong>
              Cancellations less than 2 hours Before the Scheduled Slot:
            </strong>
          </p>
          <ul className="legal-list">
            <li>Platform fee is non-refundable.</li>
            <li>
              Full payment made: 80% of the full amount will be refunded to the
              user via the original mode of payment, 15% will be paid to the
              vendor, and 5% will be retained by the App.
            </li>
            <li>
              Advance payment only: 0% of the advance payment will be refunded
              to the user, 75% of the advance payment will be paid to the
              vendor, and 25% will be retained by the App.
            </li>
          </ul>
          <p className="legal-note">
            <strong>Note:</strong> Refund processing timelines will be defined
            separately in agreement with platform policy.
          </p>

          <h4 className="legal-sub-sub-title">CAR WASH:</h4>
          <p>
            <strong>
              Cancellations 1 Hour or More before the Scheduled Slot:
            </strong>
          </p>
          <ul className="legal-list">
            <li>Platform fee is non-refundable.</li>
            <li>
              Full payment made: 95% of the full amount will be refunded to the
              user through the original payment method, while 5% will be
              retained by the app.
            </li>
            <li>
              Advance payment only: 75% of the advance payment will be refunded
              to the user through the original payment method while 25% will be
              retained by the app.
            </li>
          </ul>
          <p>
            <strong>
              Cancellations less than 1 hour Before the Scheduled Slot:
            </strong>
          </p>
          <ul className="legal-list">
            <li>Platform fee is non-refundable.</li>
            <li>
              Full payment made: 80% of the Full amount will be refunded to the
              user via the original mode of payment, 15% will be paid to the
              vendor, and 5% will be retained by the App.
            </li>
            <li>
              Advance payment only: 0% of the amount will be refunded to the
              user, 75% of the advance amount will be paid to the vendor, and
              25% will be retained by the App.
            </li>
          </ul>
          <p className="legal-note">
            <strong>Note:</strong> Refund timelines to be finalized as per
            Fewas Technologies' standard refund policy.
          </p>

          <h3 className="legal-subsection-title">
            7.3 Cancellation by Fewas Technologies Private Limited
          </h3>
          <p>
            Fewas Technologies Private Limited reserves the right to cancel any
            booking in the event of technical errors, fraud suspicion, or
            violation of terms, with or without notice.
          </p>
          <ul className="legal-list">
            <li>Vendors shall not be charged any cancellation fee.</li>
            <li>
              If service preparation or material usage has already commenced,
              reasonable compensation may be considered at Fewas Technologies
              Private Limited discretion.
            </li>
          </ul>

          <h3 className="legal-subsection-title">7.4 Force Majeure</h3>
          <p>
            No cancellation charges shall apply in case of force majeure events
            (e.g., natural disasters, power failure, government restrictions)
            duly communicated and supported by valid evidence.
          </p>

          <h3 className="legal-subsection-title">7.5 Dispute Resolution</h3>
          <p>
            Any disputes regarding cancellation charges shall be reviewed by
            Fewas Technologies Private Limited. The Company's decision will be
            final and binding, unless otherwise governed by local laws.
          </p>
        </section>

        {/* 8. Rescheduling */}
        <section className="legal-section">
          <h2 className="legal-section-title">8. Rescheduling Method and Charges</h2>
          <p>Vendor is not allowed to reschedule the scheduled user slot.</p>

          <h3 className="legal-subsection-title">Rescheduling by User</h3>

          <h4 className="legal-sub-sub-title">CAR WASH USER</h4>
          <ul className="legal-list">
            <li>
              Users may reschedule their booking once only, and free of charge,
              provided the request is made at least 1 hour prior to the
              scheduled slot time within the same day.
            </li>
            <li>
              Once a booking has been rescheduled, no further cancellations or
              modifications will be permitted.
            </li>
            <li>
              No reschedule option given to reschedule a booking for next day.
            </li>
          </ul>

          <h4 className="legal-sub-sub-title">TURF</h4>
          <ul className="legal-list">
            <li>
              Users may reschedule their booking once only, and free of charge,
              provided the request is made at least 2 hours prior to the
              scheduled slot time.
            </li>
            <li>
              A Booking Only allowed Reschedule with the same turf and same
              game, subject to available slots.
            </li>
            <li>
              Once a booking has been rescheduled, no further cancellations or
              modifications will be permitted.
            </li>
          </ul>

          <h3 className="legal-subsection-title">
            Rescheduling by Fewas Technologies Private Limited
          </h3>
          <p>
            Fewas Technologies Private Limited may reschedule services in rare
            cases such as system outages, vendor unavailability, or in the
            interest of service quality and customer satisfaction.
          </p>
          <ul className="legal-list">
            <li>
              Users and vendors will be notified at the earliest possible time.
            </li>
            <li>
              No charges shall apply to either party, and alternate options may
              be provided.
            </li>
          </ul>

          <h3 className="legal-subsection-title">Notification and Confirmation</h3>
          <p>
            All rescheduling requests must be confirmed via the Fewas
            Technologies Private Limited mobile application, vendor dashboard,
            or official written communication (email/SMS).
          </p>
          <p>
            Services are considered successfully rescheduled only upon receipt
            of confirmation from the system or Fewas Technologies Private
            Limited support team.
          </p>

          <h3 className="legal-subsection-title">Dispute Handling</h3>
          <p>
            In the event of a disagreement regarding rescheduling charges or
            terms, the matter shall be reviewed and resolved by Fewas
            Technologies Private Limited. The Company's decision shall be final
            and binding.
          </p>

          <h3 className="legal-subsection-title">Additional Conditions</h3>
          <ul className="legal-list">
            <li>
              If a user fails to show up for the slot and doesn't respond within
              15 minutes of the scheduled time, the vendor may reassign the slot.
            </li>
            <li>Clause 1 does not apply to users who paid the full amount.</li>
            <li>
              No refund will be provided if a user fails to show up for the
              scheduled slot time.
            </li>
            <li>
              Qslot (Fewas Technologies) is not responsible for any offline
              arrangements between vendor and user.
            </li>
          </ul>
        </section>

        {/* 9. Vendor Branding */}
        <section className="legal-section">
          <h2 className="legal-section-title">
            9. Use of Vendor Branding, Name, Logo, and Slogan
          </h2>

          <h3 className="legal-subsection-title">
            9.1 Consent for Display and Promotional Use
          </h3>
          <p>
            By providing consent to this Agreement, the Vendor expressly
            authorizes Fewas Technologies Private Limited to use the Vendor's
            shop name, business name, logo (if any), and slogan or tagline (if
            any), collectively referred to as "Vendor Branding Elements," for the
            purpose of displaying and promoting the Vendor's services to
            end-users through the Company's digital platforms and associated
            promotional materials.
          </p>
          <p>This includes, but is not limited to:</p>
          <ul className="legal-list">
            <li>
              Displaying the Vendor's branding elements on the user-facing
              sections of the Company's mobile applications and websites.
            </li>
            <li>
              Featuring the Vendor in banners, listings, promotional carousels,
              or offers to enhance visibility and discoverability.
            </li>
            <li>
              Using Vendor Branding Elements in marketing campaigns, including
              email newsletters, in-app notifications, digital advertisements,
              social media, or physical/digital flyers, where relevant and
              appropriate.
            </li>
          </ul>

          <h3 className="legal-subsection-title">
            9.2 Nature and Scope of License
          </h3>
          <p>
            The Vendor grants the Company a non-exclusive, royalty-free,
            worldwide, and revocable license to use, display, reproduce, and
            communicate the Vendor Branding Elements solely for the
            above-mentioned purposes. The license is granted for the duration of
            the Vendor's active association with the Company or until such
            consent is formally withdrawn, as outlined below.
          </p>

          <h3 className="legal-subsection-title">
            9.3 Representation of No Objection
          </h3>
          <p>
            The Vendor affirms that they have no objection to the Company using
            the Vendor Branding Elements in accordance with this clause. The
            Vendor understands that such use is purely promotional and
            supportive of the Vendor's commercial interests within the platform
            and will not misrepresent or alter the identity or goodwill of the
            Vendor.
          </p>

          <h3 className="legal-subsection-title">
            9.4 Intellectual Property Ownership
          </h3>
          <p>
            All intellectual property rights in the Vendor's shop name, logo,
            slogan, and associated branding elements shall remain the exclusive
            property of the Vendor. The Company acknowledges that it shall not
            assert any ownership, trademark, copyright, or proprietary interest
            in any Vendor Branding Elements used under this Agreement.
          </p>

          <h3 className="legal-subsection-title">9.5 Right to Revoke Consent</h3>
          <p>
            The Vendor has the right to revoke the consent granted under this
            clause at any time by providing written notice to the Company via
            email or other accepted channels. Upon receipt of such notice, the
            Company will cease further use and will remove the Vendor Branding
            Elements from all promotional and display assets within a
            commercially reasonable time frame, not exceeding fifteen (15)
            business days from the date of notice.
          </p>

          <h3 className="legal-subsection-title">9.6 Vendor's Warranties</h3>
          <p>The Vendor represents and warrants that:</p>
          <ul className="legal-list">
            <li>
              They have the full authority, ownership rights, or legal license
              to use and authorize the use of the shop name, logo, slogan, and
              any other branding elements.
            </li>
            <li>
              The use of such materials by the Company will not infringe upon
              any third-party intellectual property or contractual rights.
            </li>
          </ul>

          <h3 className="legal-subsection-title">9.7 Indemnity</h3>
          <p>
            The Vendor agrees to indemnify, defend, and hold harmless the
            Company, its directors, employees, affiliates, and agents from and
            against any claims, damages, losses, liabilities, or legal
            proceedings (including reasonable legal fees) arising out of or in
            connection with:
          </p>
          <ul className="legal-list">
            <li>
              Any alleged or actual infringement of third-party intellectual
              property rights resulting from the use of Vendor Branding
              Elements.
            </li>
            <li>
              Any misrepresentation by the Vendor regarding the ownership or
              licensing rights of the branding materials.
            </li>
          </ul>
        </section>

        {/* 10. Non-Exclusivity */}
        <section className="legal-section">
          <h2 className="legal-section-title">10. Non-Exclusivity</h2>
          <p>
            This Agreement is non-exclusive. Vendors may list on other
            platforms. Similarly, the Company reserves the right to partner with
            multiple vendors in the same geographical location.
          </p>
        </section>

        {/* 11. Intellectual Property */}
        <section className="legal-section">
          <h2 className="legal-section-title">11. Intellectual Property</h2>
          <ul className="legal-list">
            <li>
              The Platform, logo, UI/UX, software code, and brand identity
              remain the sole property of Fewas Technologies Private Limited.
            </li>
            <li>
              Vendors are not allowed to copy, replicate, modify, or reverse
              engineer any part of the App.
            </li>
            <li>
              Vendors may use Platform branding for marketing only with prior
              written approval.
            </li>
          </ul>
        </section>

        {/* 12. Cancellation and Termination */}
        <section className="legal-section">
          <h2 className="legal-section-title">12. Cancellation and Termination</h2>

          <h3 className="legal-subsection-title">By Vendor</h3>
          <p>
            Vendors may terminate their association by giving 15 days' prior
            written notice.
          </p>

          <h3 className="legal-subsection-title">By Company</h3>
          <p>
            The Company may terminate this Agreement or suspend Vendor access:
          </p>
          <ul className="legal-list">
            <li>For breach of terms</li>
            <li>Customer complaints</li>
            <li>Legal non-compliance</li>
            <li>Misuse of platform or fraudulent activity</li>
          </ul>

          <h3 className="legal-subsection-title">Post-Termination</h3>
          <ul className="legal-list">
            <li>
              Outstanding dues (if any) must be settled within 15 days.
            </li>
            <li>
              Access to the dashboard and user data will be revoked immediately.
            </li>
          </ul>
        </section>

        {/* 13. Confidentiality */}
        <section className="legal-section">
          <h2 className="legal-section-title">13. Confidentiality &amp; Data Protection</h2>
          <ul className="legal-list">
            <li>
              Vendor must maintain the confidentiality of all business,
              technical, or user-related information obtained via the Platform.
            </li>
            <li>
              User data such as phone numbers, emails, location, or preferences
              may only be used to fulfil the service and must not be shared or
              sold.
            </li>
            <li>
              All data handling must comply with applicable privacy laws,
              including the Information Technology Act, 2000 and the Digital
              Personal Data Protection Act, 2023 (India).
            </li>
          </ul>
        </section>

        {/* 14. Representations */}
        <section className="legal-section">
          <h2 className="legal-section-title">14. Representations and Warranties</h2>
          <p>The Vendor represents that:</p>
          <ul className="legal-list">
            <li>All information provided is accurate and up-to-date.</li>
            <li>
              The services offered are lawful and comply with all regulatory
              standards.
            </li>
            <li>
              The Vendor has the legal authority to enter into this Agreement.
            </li>
          </ul>
          <p>
            The Company makes no warranty about uninterrupted availability of
            the App but will take reasonable steps to ensure consistent service.
          </p>
        </section>

        {/* 15. Indemnity */}
        <section className="legal-section">
          <h2 className="legal-section-title">15. Indemnity</h2>
          <p>
            The Vendor agrees to indemnify, defend, and hold harmless the
            Company, its employees, and officers from any claims, damages,
            losses, liabilities, costs, or expenses arising out of:
          </p>
          <ul className="legal-list">
            <li>Breach of any terms</li>
            <li>Service failure or negligence</li>
            <li>User disputes or third-party claims</li>
          </ul>
        </section>

        {/* 16. Limitation of Liability */}
        <section className="legal-section">
          <h2 className="legal-section-title">16. Limitation of Liability</h2>
          <ul className="legal-list">
            <li>
              The Company acts as a facilitator and is not responsible for the
              actions or omissions of Vendors.
            </li>
            <li>
              In no case shall the Company's aggregate liability exceed the
              total commission received from the concerned vendor in the past 3
              months.
            </li>
          </ul>
        </section>

        {/* 17. Dispute Resolution */}
        <section className="legal-section">
          <h2 className="legal-section-title">17. Dispute Resolution</h2>
          <ul className="legal-list">
            <li>
              Any disputes shall be first attempted to be resolved through
              mutual negotiation.
            </li>
            <li>
              If unresolved, disputes shall be settled via arbitration under the
              Arbitration and Conciliation Act, 1996.
            </li>
            <li>
              <strong>Jurisdiction:</strong> Courts of Coimbatore, Tamil Nadu,
              India, shall have exclusive jurisdiction.
            </li>
          </ul>
        </section>

        {/* 18. Force Majeure */}
        <section className="legal-section">
          <h2 className="legal-section-title">18. Force Majeure</h2>
          <p>
            Neither party shall be held liable for failure to perform their
            obligations if such failure arises due to events beyond their
            control, such as natural disasters, war, pandemic, governmental
            orders, or cyber-attacks.
          </p>
        </section>

        {/* 19. Entire Agreement */}
        <section className="legal-section">
          <h2 className="legal-section-title">19. Entire Agreement &amp; Amendments</h2>
          <p>This Agreement:</p>
          <ul className="legal-list">
            <li>Represents the entire understanding between the parties.</li>
            <li>Supersedes any prior verbal or written communications.</li>
            <li>
              May be amended from time to time with prior notification via email
              or App notice.
            </li>
          </ul>
        </section>

        {/* 20. Contact */}
        <section className="legal-section">
          <h2 className="legal-section-title">20. Contact and Notices</h2>
          <p>
            Any notices or communications under this Agreement shall be sent to:
          </p>
          <ul className="legal-contact-list">
            <li>
              <strong>Company:</strong> Fewas Technologies Private Limited
            </li>
            <li>
              <strong>Address:</strong> No.32, Masakalipalayam Road,
              Lakshmipuram 4th Street, Peelamedu, Coimbatore – 641004
            </li>
            <li>
              <strong>Email:</strong>{' '}
              <a href="mailto:support@queeslot.com">support@queeslot.com</a>
            </li>
          </ul>
        </section>

        {/* 21. Acknowledgement */}
        <section className="legal-section">
          <h2 className="legal-section-title">21. Acknowledgement and Acceptance</h2>
          <p>
            By registering on the Platform and accepting these terms, the Vendor
            agrees to comply with all clauses and accepts that acceptance is
            legally binding.
          </p>
        </section>
      </main>
    </div>
  );
};

export default VendorTerms;